import React from 'react';
import classNames from 'clsx';

import { DefaultFormRowContainerProps } from './DefaultFormRowContainer.interface';
import { useStyles } from './DefaultFormRowContainer.styles';

export default function DefaultFormRowContainer({
  children,
  className,
  noMargin,
  noNegativeMarginTop,
  noPadding,
  formName,
  ...restProps
}: DefaultFormRowContainerProps) {
  const classes = useStyles();

  return (
    <div
      className={classNames(
        classes.root,
        noMargin ? classes.spacesWithoutMarginBottom : classes.spaces,
        {
          [classes.noPadding]: noPadding,
          [classes.noNegativeMarginTop]: noNegativeMarginTop,
        },
        className
      )}
      {...restProps}
    >
      {children}
    </div>
  );
}
